module.exports = __webpack_public_path__ + "static/media/scream.a294068c.jpeg";